import { inject } from '@angular/core';
import { AuthService } from '../data-access/auth.service';
import {map, shareReplay, take} from 'rxjs';
import {Dashboard, DashboardService} from "../../shared/utils/dashboard-service";
import {environment} from "../../../environments/environment";

export type Permission = 'ADMIN' | 'INSTRUCTOR' | 'STUDENT' | undefined;

export const permissionsGuard = (permissions: string) => {
  const authService = inject(AuthService);
  const dashboardService = inject(DashboardService)

  let examStudentDashboard = false
  let examAdminDashboard = false
  let newPermissions = 'ExamAdminDash'

  return authService.checkPermissions().pipe(
    take(1),
    map((permission) => {
      if(permission.success) {
        for(let result of permission.result) {
          if(result.ui != null) {
            if(result.ui.includes('ExamStudentDash')) {
              examStudentDashboard = true
            }
            if(result.ui.includes('ExamAdminDash')) {
              examAdminDashboard = true
            }
          }
        }
        if(examStudentDashboard && examAdminDashboard) {
          dashboardService.sharedData.subscribe(data=>{
            if(data === Dashboard.placement_student)
              newPermissions='ExamStudentDash'
            else if(data === Dashboard.classroom_student)
              newPermissions='ClassroomStudentDash'
          })
        }
        if(!(examStudentDashboard && examAdminDashboard)) {
          for (let result of permission.result) {
            if (result.ui != null && result.ui.includes(permissions)) {
              return true
            }
          }
          return false
        } else {
          return permissions === newPermissions
        }
      } else {
        return permissions === 'FORBIDDEN'
      }
    })
  );
};
